/**
 * @generated SignedSource<<f3f70f16d3f938c63be31850e375de62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CustomDomainStatus = "ACTIVE" | "DNS_RECORD_MISSING" | "NOT_PAID" | "%future added value";
export type OnboardingType = "CLIENT" | "CONTRACTOR" | "%future added value";
export type TopIndependentStatus = "DISCOVERED" | "OPTED_IN" | "OPTED_OUT" | "UNDISCOVERED" | "%future added value";
export type UserFeature = "ACCESS_CONTRA_LABS_QA" | "ADD_NOTE_TO_CONTACT_OWN" | "ADD_NOTE_TO_CONTACT_OWN_ORGANIZATION" | "APPLY_TO_JOB" | "APPLY_TO_JOB_POSTING" | "ARCHIVE_JOB_POSTING_ALL" | "ARCHIVE_JOB_POSTING_OWN" | "ARCHIVE_JOB_POSTING_OWNR_TEAM" | "ARCHIVE_JOB_POSTING_OWN_ORGANIZATION" | "AUTOMATICALLY_APPROVE_PAID_PROJECT_INVITE" | "AUTOMATICALLY_MATCH_WITH_CREATED_JOB_POSTINGS" | "AUTOMATICALLY_RATE_PROFILE" | "BLOCK_USERS" | "BRANCH_ADS_SHOW_DISCOVER_PROJECTS_SECTION_AD" | "BRANCH_ADS_SHOW_JOB_FEED_AD" | "BRANCH_ADS_SHOW_SIDE_NAV_AD" | "C4C_REFERRAL_PROGRAM" | "CAN_ACCESS_INDY_AI_PRO_FEED" | "CAN_SEE_MESSAGE_PAGE_UPDATES" | "CAN_USE_CHAT_IN_POPUP" | "CAN_USE_INDY_AI" | "CAN_USE_INDY_AI_ONBOARDING" | "CHANGE_ORGANIZATION_MEMBER_ROLE_OWN_ORGANIZATION" | "CHAT_ENABLED" | "CHECK_FOR_INAPPROPRIATE_CONTENT" | "CLAIM_ORGANIZATION" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_AUTO_FEATURE_PUBLISHED_POSTS" | "COMMUNITY_FEED_CANNOT_POST" | "COMMUNITY_FEED_CAN_BOOST_SOCIAL_POST" | "COMMUNITY_FEED_CAN_CURATE" | "COMMUNITY_FEED_CAN_DELETE_SOCIAL_POST" | "COMMUNITY_FEED_CAN_FEATURE_SOCIAL_POST" | "COMMUNITY_FEED_CAN_MANAGE_ADMIN_TAGS" | "COMMUNITY_FEED_CAN_MODERATE_POST" | "COMMUNITY_FEED_CAN_POST" | "COMMUNITY_FEED_CAN_VIEW_FEED" | "CONTRA_MAX_SUBSCRIBER" | "CONTRA_PRO_SUBSCRIBER" | "CREATE_COMMUNITY_JOB_POSTINGS" | "CREATE_CURATED_PROJECT_LISTS" | "CREATE_JOB_OWN" | "CREATE_JOB_OWN_ORGANIZATION" | "CREATE_JOB_OWN_TEAM" | "CREATE_JOB_POSTING" | "CREATE_JOB_POSTING_OWN" | "CREATE_JOB_POSTING_OWN_ORGANIZATION" | "CREATE_JOB_POSTING_OWN_TEAM" | "CREATE_MANUAL_TEST_USER" | "CREATE_PAID_PROJECT_INQUIRY" | "CREATE_PAID_PROJECT_INVITE" | "DEFAULT_REFERRAL_PROGRAM" | "DELETE_SOCIAL_POST" | "DELETE_USERS" | "EDIT_CONTACT_OWN" | "EDIT_CONTACT_OWN_ORGANIZATION" | "EDIT_JOB_ALL" | "EDIT_JOB_OWN" | "EDIT_JOB_OWN_ORGANIZATION" | "EDIT_JOB_OWN_TEAM" | "EDIT_JOB_POSTING_DETAILS_ALL" | "EDIT_JOB_POSTING_DETAILS_OWN" | "EDIT_JOB_POSTING_DETAILS_OWN_ORGANIZATION" | "EDIT_JOB_POSTING_DETAILS_OWN_TEAM" | "EDIT_ORGANIZATION_DETAILS_ALL" | "EDIT_ORGANIZATION_DETAILS_OWN_ORGANIZATION" | "ENABLE_CONTRA_FOR_COMPANIES_FOR_ORGANIZATION" | "ENABLE_PARTNER_CREATOR_AFFILIATE_ADS" | "FAST_FORWARD_CADENCE_CYCLE" | "FEATURE_SOCIAL_POST" | "FIFTY_PERCENT_COUPON_OFF_CONTRA_PRO" | "FOUNDED_ADS_SHOW_ANALYTICS_TAB_AD" | "FOUNDED_ADS_SHOW_EXPERT_PAGE_AD" | "FOUNDED_ADS_SHOW_INDEPENDENT_HOME_AD" | "FOUNDED_ADS_SHOW_INVOICE_CREATION_SCREEN_AD" | "FOUNDED_ADS_SHOW_JOBS_PAGE_AD" | "FOUNDED_ADS_SHOW_PAYMENTS_SCREEN_AD" | "FOUNDED_ADS_SHOW_PAYOUT_MODAL_AD" | "FOUNDED_ADS_SHOW_PAYOUT_MODAL_DROPDOWN_AD" | "FOUNDED_ADS_SHOW_PROJECT_CREATION_AD" | "FRAMER_AD_EXPERIMENT_SHOW_ANALYTICS_TAB_AD" | "FRAMER_AD_EXPERIMENT_SHOW_EXPERT_PAGE_AD" | "FRAMER_AD_EXPERIMENT_SHOW_INDEPENDENT_HOME_AD" | "FRAMER_AD_EXPERIMENT_SHOW_JOBS_PAGE_AD" | "FRAMER_AD_EXPERIMENT_SHOW_PROJECT_CREATION_AD" | "FRAMER_AD_EXPERIMENT_SHOW_SERVICES_CREATION_AD" | "FRAMER_AD_EXPERIMENT_SHOW_SIDE_NAV_AD" | "FRAUD_REVIEW_REQUIRED_FOR_TEST_USERS" | "GENERAL_ASSEMBLY_ADS_SHOW_ANALYTICS_TAB_AD" | "GENERAL_ASSEMBLY_ADS_SHOW_EXPERT_PAGE_AD" | "GENERAL_ASSEMBLY_ADS_SHOW_INDEPENDENT_DISCOVERY_PAGE_AD" | "GENERAL_ASSEMBLY_ADS_SHOW_INDEPENDENT_HOME_AD" | "GENERAL_ASSEMBLY_ADS_SHOW_JOBS_PAGE_AD" | "GENERAL_ASSEMBLY_ADS_SHOW_PROJECT_CREATION_AD" | "GENERAL_ASSEMBLY_ADS_SHOW_SERVICES_CREATION_AD" | "GENERAL_ASSEMBLY_ADS_SHOW_SIDE_NAV_AD" | "GENERATE_INTERNAL_SLACK_NOTIFICATIONS" | "HAS_GROUP_CHAT_COMPOSER_ACCESS" | "HAS_INTAKE_AGENT_ACCESS" | "HAS_SELECTED_COMMUNITY_ONBOARDING" | "HIDE_CONTRACTOR_COMPLETE_PROFILE_CHECKLIST" | "HIDE_FROM_ANALYTICS" | "HIDE_FROM_SEARCH_ENGINES" | "HIDE_FROM_USER_SEARCH" | "HIDE_FROM_USER_SUGGESTIONS" | "HOVER_ADS_SHOW_CUSTOM_DOMAIN_PAGE_AD" | "HOVER_ADS_SHOW_DISCOVER_PROJECTS_SECTION_AD" | "HOVER_ADS_SHOW_JOB_FEED_AD" | "HOVER_ADS_SHOW_PROFILE_ABOUT_SECTION_AD" | "HOVER_ADS_SHOW_SOCIAL_LINKS_MODAL_AD" | "IMPERSONATE_USERS" | "IMPORT_EXPERT_PROFILES" | "IMPORT_PORTFOLIO_PROJECT" | "INDEXABLE_BY_SEARCH_ENGINES" | "INDEXABLE_FOR_USER_SEARCH" | "INSTANT_ACCESS_TO_JOB_POSTINGS" | "INVITE_ORGANIZATION_MEMBER_ROLE_ADMIN_OWN_ORGANIZATION" | "INVITE_ORGANIZATION_MEMBER_ROLE_MEMBER_OWN_ORGANIZATION" | "LIST_ORGANIZATION_MEMBERS_OWN_ORGANIZATION" | "MANAGE_ACH_PAYMENT_REQUESTS" | "MANAGE_ADS" | "MANAGE_BASIC_OPPORTUNITIES" | "MANAGE_CONTRA_LABS_APPLICATIONS" | "MANAGE_CONTRA_LABS_NETWORK" | "MANAGE_DIRECT_PAYMENTS" | "MANAGE_DISCOVER_FEATURED_TAGS" | "MANAGE_DISCOVER_SECTIONS" | "MANAGE_EXCLUSIVE_OPPORTUNITIES" | "MANAGE_FIRC_FEES" | "MANAGE_HIRING_CREDITS" | "MANAGE_INBOUND_BANK_TRANSFERS" | "MANAGE_INDEPENDENT_PORTFOLIO_TEMPLATES" | "MANAGE_JOB_BOOST_REQUESTS" | "MANAGE_JOB_POSTINGS" | "MANAGE_JOB_POSTING_APPLICANTS_ALL" | "MANAGE_JOB_POSTING_APPLICANTS_OWN" | "MANAGE_JOB_POSTING_APPLICANTS_OWN_ORGANIZATION" | "MANAGE_JOB_POSTING_APPLICANTS_OWN_TEAM" | "MANAGE_LEDGER_TRANSACTIONS" | "MANAGE_LISTS" | "MANAGE_NOTIFICATIONS" | "MANAGE_ORGANIZATIONS" | "MANAGE_ORGANIZATION_CLAIM_REQUESTS" | "MANAGE_ORGANIZATION_JOIN_REQUEST_FOR_ALL" | "MANAGE_PAID_PROJECTS_ALL" | "MANAGE_PAID_PROJECTS_OWN" | "MANAGE_PAID_PROJECTS_OWN_ORGANIZATION" | "MANAGE_PAID_PROJECTS_OWN_TEAM" | "MANAGE_PAID_PROJECT_INQUIRIES" | "MANAGE_PAYMENT_METHODS_OWN" | "MANAGE_PAYMENT_METHODS_OWN_ORGANIZATION" | "MANAGE_PAYMENT_REVIEWS" | "MANAGE_PROFESSIONAL_ROLES" | "MANAGE_PROFESSIONAL_TOOLS" | "MANAGE_SECURITY_ASSESSMENT" | "MANAGE_STUDIO_DIRECTORY" | "MANAGE_THEME_CUSTOMIZATION" | "MANAGE_USER_GROUPS" | "MANAGE_USER_INTERFACE_FLAGS" | "MANAGE_USER_WAITLISTS" | "MANAGE_WORKSPACE_GROUPS" | "MANUAL_LEDGER_ENTRY" | "MAY_HOLD_PAYOUTS" | "MERCURY_ADS_SHOW_INVOICE_CREATION_SCREEN_AD" | "MERCURY_ADS_SHOW_INVOICE_VIEW_SCREEN_AD" | "MERCURY_ADS_SHOW_PAYMENTS_SCREEN_AD" | "MERCURY_ADS_SHOW_PAYMENTS_SCREEN_CLIENT_AD" | "MERCURY_ADS_SHOW_PAYMENT_ADD_SCREEN_ACH_AD" | "MERCURY_ADS_SHOW_PAYMENT_ADD_SCREEN_CC_AD" | "MERCURY_ADS_SHOW_PAYOUT_MODAL_AD" | "OFFER_AUTOMATIC_INVOICE_PAYMENT" | "PERCENTAGE_OR_FIXED_REFERRALS" | "POPULATE_COMMUNITY_FEED" | "POST_SOCIAL_POST_INTERNAL_TEAM_ONLY" | "PROFILE_INTRODUCTION_VIDEO" | "PROVISION_PUBLIC_API_KEY" | "PUBLISH_INDEPENDENT_PORTFOLIO" | "RATE_USERS" | "RECEIVE_EMAILS" | "RECEIVE_INDY_ONBOARDING_WELCOME_EMAILS" | "RECEIVE_PAID_PROJECT_INQUIRY" | "REFERRAL_PROGRAM_MEMBER" | "RELUME_ADS_SHOW_ANALYTICS_TAB_AD" | "RELUME_ADS_SHOW_EXPERT_PAGE_AD" | "RELUME_ADS_SHOW_INDEPENDENT_HOME_AD" | "RELUME_ADS_SHOW_JOBS_PAGE_AD" | "RELUME_ADS_SHOW_PROJECT_CREATION_AD" | "RELUME_ADS_SHOW_SERVICES_CREATION_AD" | "RELUME_ADS_SHOW_SIDE_NAV_AD" | "REQUEST_JOB_POSTING_IMPORT" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN_ORGANIZATION" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN_TEAM" | "REQUIRE_CONTRACT_SIGNATURE" | "RESET_AIRWALLEX_ACCOUNTS" | "RESOLVE_PAID_PROJECT_DISPUTES" | "RESTORE_LEDGER_BALANCE_FOR_FAILED_PAYOUTS" | "RHO_ADS_SHOW_INVOICE_CREATION_SCREEN_AD" | "RHO_ADS_SHOW_INVOICE_VIEW_SCREEN_AD" | "RHO_ADS_SHOW_PAYMENTS_SCREEN_AD" | "RHO_ADS_SHOW_PAYMENTS_SCREEN_CLIENT_AD" | "RHO_ADS_SHOW_PAYMENT_ADD_SCREEN_ACH_AD" | "RHO_ADS_SHOW_PAYMENT_ADD_SCREEN_CC_AD" | "RHO_ADS_SHOW_PAYOUT_MODAL_AD" | "RHO_ADS_SHOW_SIDE_NAV_AD" | "SEARCH_COMMUNITY_JOBS" | "SEARCH_TEST_USERS" | "SEARCH_USERS" | "SEND_ARBITRARY_GRAPHQL_REQUESTS" | "SEND_DM_CAMPAIGN" | "SERVICE_INTRODUCTION_VIDEO" | "SET_PROFILE_APPROVAL_STATUS" | "SET_USER_ONBOARDING_TYPE" | "SHARED_NETWORK" | "SHOW_DISCOVER_PROFILE_PREVIEW_CARD" | "SHOW_IN_USER_SEARCH" | "SKIP_AUTOMATED_JOB_POSTING_MATCHING" | "SKIP_AUTO_RATING" | "SKIP_CREATIVE_ARENA_MODERATION" | "SKIP_INAPPROPRIATE_CONTENT_CHECK" | "SKIP_SENDING_CHAT_MESSAGES" | "SKIP_SENDING_EMAILS" | "SKIP_SENDING_INTERNAL_SLACK_NOTIFICATIONS" | "SKIP_SIGNING_CONTRACT" | "SOCIAL_REFERRAL_PROGRAM" | "STONKS_ADS_SHOW_INVOICE_CREATION_SCREEN_AD" | "STONKS_ADS_SHOW_INVOICE_VIEW_SCREEN_AD" | "STONKS_ADS_SHOW_PAYMENTS_SCREEN_AD" | "STONKS_ADS_SHOW_PAYOUT_MODAL_AD" | "SUBSCRIBE_TO_PORTFOLIOS" | "SYNC_WITH_ANALYTICS" | "UNLIMITED_SUPER_LIKE_QUOTA" | "USER_DATA_INCLUDED_IN_SUGGESTIONS" | "USE_CLIENT_SHORTCUTS_MENU" | "USE_CONTRACTOR_SHORTCUTS_MENU" | "USE_CRYPTO_SANDBOX" | "USE_EVERSIGN_SANDBOX" | "USE_LEDGER_SANDBOX" | "USE_PAYONEER_SANDBOX" | "USE_PAYPAL_SANDBOX" | "USE_PERSONA_SANDBOX" | "USE_STRIPE_SANDBOX" | "VIEW_INVOICE_ALL" | "VIEW_INVOICE_OWN" | "VIEW_INVOICE_OWN_ORGANIZATION" | "VIEW_INVOICE_OWN_TEAM" | "VIEW_IN_DEVELOPMENT_PORTFOLIO_TEMPLATES" | "VIEW_JOBS_ALL" | "VIEW_JOBS_OWN" | "VIEW_JOBS_OWN_ORGANIZATION" | "VIEW_JOBS_OWN_TEAM" | "VIEW_JOB_FEED" | "VIEW_JOB_POSTINGS_ALL" | "VIEW_JOB_POSTINGS_OWN_ORGANIZATION" | "VIEW_JOB_POSTINGS_OWN_TEAM" | "VIEW_JOB_POSTING_OWN" | "VIEW_PAID_PROJECTS_ALL" | "VIEW_PAID_PROJECTS_OWN" | "VIEW_PAID_PROJECTS_OWN_ORGANIZATION" | "VIEW_PAID_PROJECTS_OWN_TEAM" | "VIEW_SOCIAL_POST_INTERNAL_TEAM_ONLY" | "VIEW_SOCIAL_POST_RATING_DETAILS" | "VISUAL_ELECTRIC_ADS_SHOW_ANALYTICS_TAB_AD" | "VISUAL_ELECTRIC_ADS_SHOW_EXPERT_PAGE_AD" | "VISUAL_ELECTRIC_ADS_SHOW_INDEPENDENT_HOME_AD" | "VISUAL_ELECTRIC_ADS_SHOW_JOBS_PAGE_AD" | "VISUAL_ELECTRIC_ADS_SHOW_PROJECT_CREATION_AD" | "VISUAL_ELECTRIC_ADS_SHOW_SERVICES_CREATION_AD" | "VISUAL_ELECTRIC_ADS_SHOW_SIDE_NAV_AD" | "WAIVE_BANK_TRANSFER_FEES" | "WAIVE_CRYPTO_FEES" | "WAIVE_FASTER_PAYOUT_FEES" | "WIX_STUDIO_ADS_SHOW_ANALYTICS_TAB_AD" | "WIX_STUDIO_ADS_SHOW_EXPERT_PAGE_AD" | "WIX_STUDIO_ADS_SHOW_INDEPENDENT_HOME_AD" | "WIX_STUDIO_ADS_SHOW_JOBS_PAGE_AD" | "WIX_STUDIO_ADS_SHOW_PROJECT_CREATION_AD" | "WIX_STUDIO_ADS_SHOW_SERVICES_CREATION_AD" | "WIX_STUDIO_ADS_SHOW_SIDE_NAV_AD" | "%future added value";
export type UserGroup = "ACTIVE_USER" | "ADMIN" | "AGENT_COMMERCE_OPTED_IN" | "AGENT_EXPERT" | "ANSWER_HQ_EXPERT" | "ANYTHING_EXPERT" | "AUTOMATIC_INVOICE_PAYMENT_EARLY_ACCESS" | "BASE44_EXPERT" | "BLOCKED_USER" | "BOLT_EXPERT" | "BOLT_MENTOR_EXPERT" | "BOTSTACKS_EXPERT" | "BRANCH_ADS_DISCOVER_PROJECTS_SECTION_AUDIENCE" | "BRANCH_ADS_JOB_FEED_AUDIENCE" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "C4C_REFERRAL_PROGRAM" | "CAPCUT_AI_VIDEO_EXPERT" | "CAPCUT_EXPERT" | "CHATBASE_EXPERT" | "CHAT_IN_POPUP_USER" | "CHAT_SKIP_PRECHECK_TEST_USERS" | "CLIENT_ONBOARDING_COMPLETE" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_CURATED_FTUE" | "COMMUNITY_FEED_BANNED_FROM_POSTING" | "COMMUNITY_FEED_CREATOR" | "COMMUNITY_FEED_CURATOR" | "COMMUNITY_FEED_FEATURED_CREATOR" | "COMMUNITY_FEED_MEMBER" | "COMMUNITY_FEED_PRIMARY_POOL_OVERRIDE" | "COMMUNITY_FEED_VIEWER" | "COMMUNITY_JOB_POSTING_MANAGER" | "COMMUNITY_MANAGER" | "COMMUNITY_ONBOARDING_COMPLETE" | "COMMUNITY_ONBOARDING_PATH" | "CONTRACTOR_ONBOARDING_COMPLETE" | "CONTRACTOR_PROFILE_COMPLETE" | "CONTRA_EXPERT_TEST" | "CONTRA_FEATURED_STUDIO" | "CONTRA_FOR_COMPANIES_CLIENT" | "CONTRA_HIRING" | "CONTRA_LABS_ADMIN" | "CONTRA_LABS_LICENSING_PARTICIPANT" | "CONTRA_LABS_NETWORK_RESTRICTED" | "CONTRA_LABS_NETWORK_USER" | "CONTRA_LABS_QA" | "CONTRA_LABS_REVIEWER" | "CONTRA_MAX_100_DOLLARS_OFF_ANNUAL_1YR" | "CONTRA_MAX_100_PERCENT_DISCOUNT_1YR" | "CONTRA_MAX_100_PERCENT_DISCOUNT_FOREVER" | "CONTRA_MAX_50_PERCENT_DISCOUNT_ANNUAL_1YR" | "CONTRA_MAX_50_PERCENT_DISCOUNT_FOREVER" | "CONTRA_MAX_50_PERCENT_DISCOUNT_MONTHLY_1YR" | "CONTRA_MAX_LEGACY_SUBSCRIBER" | "CONTRA_MAX_SUBSCRIBER" | "CONTRA_PRO_100_PERCENT_DISCOUNT_1YR" | "CONTRA_PRO_50_PERCENT_DISCOUNT_1YR" | "CONTRA_PRO_ACCESS_CODE_EVENT" | "CONTRA_PRO_OLD_PRICE_GROUP" | "CONTRA_PRO_SUBSCRIBER" | "CONTRA_PRO_TRIAL_USED" | "CONTRA_STUDIO_EXPERT" | "CONTRA_TEAM_MEMBER" | "CO_AGENT_DEFAULT_ROUTE_CONTROL" | "CO_AGENT_DEFAULT_ROUTE_TREATMENT" | "CREATOR_PORTFOLIO_EARLY_ACCESS" | "DEFAULT_REFERRAL_PROGRAM" | "DESCRIPT_EXPERT" | "DISCOVER_CURATOR" | "EXCLUDED_FROM_BANK_TRANSFER_FEES" | "EXCLUDED_FROM_CRYPTO_PAYOUT_FEES" | "EXCLUDED_FROM_DISCOVER" | "EXCLUDED_FROM_FASTER_PAYOUT_FEES" | "EXCLUDED_FROM_MATCHING" | "EXCLUDE_FROM_SEARCH_ENGINE_INDEXING" | "FLAGGED_USER" | "FLAG_FOR_IMPROVEMENT" | "FLORA_EXPERT" | "FLUTTERFLOW_AGENCY_EXPERT" | "FLUTTERFLOW_CERTIFIED_EXPERT" | "FLUTTERFLOW_EXPERT" | "FLUTTERFLOW_USER_EXPERT" | "FOUNDED_ADS_ANALYTICS_TAB_AUDIENCE" | "FOUNDED_ADS_EXPERT_PAGE_AUDIENCE" | "FOUNDED_ADS_INDEPENDENT_HOME_AUDIENCE" | "FOUNDED_ADS_INVOICE_CREATION_SCREEN_AUDIENCE" | "FOUNDED_ADS_JOBS_PAGE_AUDIENCE" | "FOUNDED_ADS_PAYMENTS_SCREEN_AUDIENCE" | "FOUNDED_ADS_PAYOUT_MODAL_AUDIENCE" | "FOUNDED_ADS_PAYOUT_MODAL_DROPDOWN_AUDIENCE" | "FOUNDED_ADS_PROJECT_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_ANALYTICS_TAB_AUDIENCE" | "FRAMER_AD_EXPERIMENT_EXPERT_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_INDEPENDENT_HOME_AUDIENCE" | "FRAMER_AD_EXPERIMENT_JOBS_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_PROJECT_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SERVICES_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SIDE_NAV_AUDIENCE" | "FRAMER_COMMERCE_EXPERT" | "FRAMER_EXPERT" | "FRAMESHIP_EXPERT" | "GENERAL_ASSEMBLY_ADS_ANALYTICS_TAB_AUDIENCE" | "GENERAL_ASSEMBLY_ADS_EXPERT_PAGE_AUDIENCE" | "GENERAL_ASSEMBLY_ADS_INDEPENDENT_DISCOVERY_PAGE_AUDIENCE" | "GENERAL_ASSEMBLY_ADS_INDEPENDENT_HOME_AUDIENCE" | "GENERAL_ASSEMBLY_ADS_JOBS_PAGE_AUDIENCE" | "GENERAL_ASSEMBLY_ADS_PROJECT_CREATION_AUDIENCE" | "GENERAL_ASSEMBLY_ADS_SERVICES_CREATION_AUDIENCE" | "GENERAL_ASSEMBLY_ADS_SIDE_NAV_AUDIENCE" | "GENERAL_ASSEMBLY_ALUMNI_EXPERT" | "GENERAL_ASSEMBLY_X_ADOBE_EXPERT" | "GLORIFY_EXPERT" | "GROUP_CHAT_COMPOSER_ACCESS" | "GUEST_JOB_APPLICANT" | "HAS_CUSTOM_EMAIL_DOMAIN" | "HIGH_RATED_USER" | "HIRED_BY_YC_EXPERT" | "HOVER_ADS_CUSTOM_DOMAIN_PAGE_AUDIENCE" | "HOVER_ADS_DISCOVER_PROJECTS_SECTION_AUDIENCE" | "HOVER_ADS_JOB_FEED_AUDIENCE" | "HOVER_ADS_PROFILE_ABOUT_SECTION_AUDIENCE" | "HOVER_ADS_SOCIAL_LINKS_MODAL_AUDIENCE" | "IDEOGRAM_EXPERT" | "INDY_AI_ONBOARDING_USER" | "INDY_AI_PRO_FEED_USER" | "INDY_AI_USER" | "INSTANT_EXPERT" | "INTAKE_AGENT_USER" | "INTEGRATION_TEST_USER" | "INTERNAL_CONTENT_CREATOR" | "JITTER_EXPERT" | "JOB_NETWORK_ACCESS_APPROVED" | "KAJABI_EXPERT" | "KITTL_EXPERT" | "LIQUIFY_PRO_EXPERT" | "LOVABLE_EXPERT" | "LOVABLE_SOLUTION_PARTNER" | "LOVART_EXPERT" | "LOW_RATED_USER" | "LUMMI_EXPERT" | "MAGICPATH_EXPERT" | "MANUALLY_VERIFIED_NO_INAPPROPRIATE_CONTENT" | "MANUAL_DEMO_USER" | "MANUAL_TEST_USER" | "MAY_HOLD_PAYOUTS_CONTRACTORS" | "MERCURY_ADS_INVOICE_CREATION_SCREEN_AUDIENCE" | "MERCURY_ADS_INVOICE_VIEW_SCREEN_AUDIENCE" | "MERCURY_ADS_PAYMENTS_SCREEN_AUDIENCE" | "MERCURY_ADS_PAYMENTS_SCREEN_CLIENT_AUDIENCE" | "MERCURY_ADS_PAYMENT_ADD_SCREEN_ACH_AUDIENCE" | "MERCURY_ADS_PAYMENT_ADD_SCREEN_CC_AUDIENCE" | "MERCURY_ADS_PAYOUT_MODAL_AUDIENCE" | "MESSAGE_PAGE_UPDATES_USER" | "MOCHA_EXPERT" | "NEW_ONBOARDING_EXPERIENCE_USER" | "ONBOARDING_TYPE_NOT_CONFIRMED" | "ORGANIZATION_MEMBER" | "ORGANIZATION_MEMBER_ROLE_ADMIN" | "ORGANIZATION_MEMBER_ROLE_CONTRA_ADMIN" | "PAGEDECK_EXPERT" | "PARTNER_CREATOR_AFFILIATE" | "PENDING_COMMUNITY_FEED_MEMBER" | "PERCENTAGE_OR_FIXED_REFERRALS" | "PLATFORM_EARNINGS_BADGE_100K" | "PLATFORM_EARNINGS_BADGE_10K" | "PLATFORM_EARNINGS_BADGE_1K" | "PLATFORM_EARNINGS_BADGE_1M" | "PLATFORM_EARNINGS_BADGE_250K" | "PLATFORM_EARNINGS_BADGE_25K" | "PLATFORM_EARNINGS_BADGE_500K" | "PLATFORM_EARNINGS_BADGE_50K" | "PLATFORM_EARNINGS_BADGE_5K" | "PLATFORM_EARNINGS_BADGE_750K" | "PORTFOLIO_DEVELOPER" | "PORTFOLIO_EARLY_ADOPTER" | "QUICK_RESPONDER" | "READYMAG_EXPERT" | "RELUME_ADS_ANALYTICS_TAB_AUDIENCE" | "RELUME_ADS_EXPERT_PAGE_AUDIENCE" | "RELUME_ADS_INDEPENDENT_HOME_AUDIENCE" | "RELUME_ADS_JOBS_PAGE_AUDIENCE" | "RELUME_ADS_PROJECT_CREATION_AUDIENCE" | "RELUME_ADS_SERVICES_CREATION_AUDIENCE" | "RELUME_ADS_SIDE_NAV_AUDIENCE" | "RELUME_EXPERT" | "REPLIT_EXPERT" | "REPLO_EXPERT" | "RETOOL_EXPERT" | "RHO_ADS_INVOICE_CREATION_SCREEN_AUDIENCE" | "RHO_ADS_INVOICE_VIEW_SCREEN_AUDIENCE" | "RHO_ADS_PAYMENTS_SCREEN_AUDIENCE" | "RHO_ADS_PAYMENTS_SCREEN_CLIENT_AUDIENCE" | "RHO_ADS_PAYMENT_ADD_SCREEN_ACH_AUDIENCE" | "RHO_ADS_PAYMENT_ADD_SCREEN_CC_AUDIENCE" | "RHO_ADS_PAYOUT_MODAL_AUDIENCE" | "RHO_ADS_SIDE_NAV_AUDIENCE" | "RIVE_EXPERT" | "SECURITY_ASSESSMENT_ADMIN" | "SECURITY_ASSESSMENT_REQUIRED" | "SHORTIMIZE_CLIENT" | "SOCIAL_FEATURE_ELIGIBLE" | "SOCIAL_REFERRAL_PROGRAM" | "SPLINE_EXPERT" | "STANDARD_CLIENT" | "STONKS_ADS_INVOICE_CREATION_SCREEN_AUDIENCE" | "STONKS_ADS_INVOICE_VIEW_SCREEN_AUDIENCE" | "STONKS_ADS_PAYMENTS_SCREEN_AUDIENCE" | "STONKS_ADS_PAYOUT_MODAL_AUDIENCE" | "TEMPO_LABS_EXPERT" | "TEST_ADMIN" | "TEST_USERS_FORCE_FRAUD_REVIEW" | "THUNKABLE_EXPERT" | "TOP_INDEPENDENT_DISCOVERED" | "TOP_INDEPENDENT_OPTED_IN" | "TOP_INDEPENDENT_OPTED_OUT" | "TOP_STUDIO" | "TRUSTED_CREATIVE_ARENA_USER" | "TRUSTED_PARTNER" | "UNICORN_HIRED_CLUB_EXPERT" | "UNICORN_STUDIO_EXPERT" | "USER_WITH_INQUIRY_AUTO_APPROVAL" | "USER_WITH_INVOICE_AUTO_APPROVAL" | "USER_WITH_JOB_POSTING_AUTO_APPROVAL" | "USER_WITH_PAID_PROJECT_INVITE_AUTO_APPROVAL" | "VISUAL_ELECTRIC_ADS_ANALYTICS_TAB_AUDIENCE" | "VISUAL_ELECTRIC_ADS_EXPERT_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_INDEPENDENT_HOME_AUDIENCE" | "VISUAL_ELECTRIC_ADS_JOBS_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_PROJECT_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SERVICES_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SIDE_NAV_AUDIENCE" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_ADS_ANALYTICS_TAB_AUDIENCE" | "WIX_STUDIO_ADS_EXPERT_PAGE_AUDIENCE" | "WIX_STUDIO_ADS_INDEPENDENT_HOME_AUDIENCE" | "WIX_STUDIO_ADS_JOBS_PAGE_AUDIENCE" | "WIX_STUDIO_ADS_PROJECT_CREATION_AUDIENCE" | "WIX_STUDIO_ADS_SERVICES_CREATION_AUDIENCE" | "WIX_STUDIO_ADS_SIDE_NAV_AUDIENCE" | "WOMP_EXPERT" | "WORKSPACE_ADDED_CONTACT" | "%future added value";
export type WaitListNid = "C4C" | "COMMUNITY_FEED" | "CONTRA_SPEND_CARD" | "CREATIVE_ARENA_WORKFLOW" | "EXPERT_NETWORKS" | "FINANCE_INTEGRATION" | "GROWTH_RECOMMENDATIONS" | "HOURLY_ONGOING_PROJECTS" | "INDEPENDENT_PORTFOLIOS_ALPHA" | "OTHER" | "PRO_ANALYTICS" | "RATE_CALCULATOR" | "SLACK_CLIENT_INTEGRATION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CurrentUserContext_userAccount$data = {
  readonly analyticsUserId: string;
  readonly customDomains: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly domain: string;
        readonly status: CustomDomainStatus;
      };
    }>;
  };
  readonly emailAddress: string | null;
  readonly id: string;
  readonly isTestAccount: boolean;
  readonly onboardingType: OnboardingType;
  readonly profile: {
    readonly avatarImage: {
      readonly uid: string;
    } | null;
    readonly displayUsername: string;
    readonly firstName: string | null;
    readonly generalInquiryCtaIsVisible: boolean;
    readonly hasActivePortfolioSubscription: boolean;
    readonly id: string;
    readonly independentPortfolioTemplateTheme: {
      readonly id: string;
      readonly template: {
        readonly displayName: string;
        readonly id: string;
      };
    } | null;
    readonly isFramerExpert: boolean;
    readonly lastName: string | null;
    readonly primaryProfessionalCategory: string | null;
    readonly receivedTestimonials: {
      readonly count: number;
    };
    readonly title: string | null;
    readonly topIndependentStatus: TopIndependentStatus;
    readonly workPreferences: {
      readonly isCurrentlyAvailable: boolean;
    };
  };
  readonly userFeatures: ReadonlyArray<UserFeature>;
  readonly userGroups: ReadonlyArray<UserGroup>;
  readonly waitLists: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly nid: WaitListNid;
      };
    }>;
  };
  readonly " $fragmentType": "CurrentUserContext_userAccount";
};
export type CurrentUserContext_userAccount$key = {
  readonly " $data"?: CurrentUserContext_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentUserContext_userAccount">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrentUserContext_userAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onboardingType",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestAccount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomDomainConnection",
      "kind": "LinkedField",
      "name": "customDomains",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomDomainEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDomain",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "domain",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraImage",
          "kind": "LinkedField",
          "name": "avatarImage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uid",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasActivePortfolioSubscription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "topIndependentStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFramerExpert",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generalInquiryCtaIsVisible",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IndependentPortfolioTemplateTheme",
          "kind": "LinkedField",
          "name": "independentPortfolioTemplateTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IndependentPortfolioTemplate",
              "kind": "LinkedField",
              "name": "template",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkPreferences",
          "kind": "LinkedField",
          "name": "workPreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCurrentlyAvailable",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReceivedTestimonialConnection",
          "kind": "LinkedField",
          "name": "receivedTestimonials",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryProfessionalCategory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUsername",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userGroups",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userFeatures",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WaitListConnection",
      "kind": "LinkedField",
      "name": "waitLists",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WaitListEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WaitList",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "nid",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};
})();

(node as any).hash = "f62911296f1e24bf514a9eead55182c5";

export default node;
